"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
var Storage = (function () {
    function Storage() {
        this.storage = {};
    }
    Storage.getInstance = function () {
        if (!Storage.instance) {
            Storage.instance = new Storage();
        }
        return Storage.instance;
    };
    Storage.prototype.set = function (id, value, expires) {
        this.storage[id] = {
            value: value,
            expires: expires,
        };
    };
    Storage.prototype.get = function (id) {
        var _a, _b;
        return (_b = (_a = this.storage[id]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [];
    };
    return Storage;
}());
exports.Storage = Storage;
